module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/03_shape-lg-4209d8a544654256f7703fd8117363cf.png";